import { BREAKPOINTS_SORTED } from '../breakpoints'
import { space } from './space'
import {
  bodyFontSize,
  fontSizes,
  fontWeights,
  lineHeights,
  fonts,
} from './typography'
import { radii, borderWidth, outline } from './borders'
import { colors } from './colors'
import { shadows } from './shadows'
import * as variants from './variants'
import { zIndex } from './zIndex'
import { letterSpacings } from './letterSpacings'
import { transitions } from './transitions'
import {
  light,
  fonts as prismFonts,
  radii as prismRadii,
  fontSizes as prismFontSizes,
} from './prism'

const breakpoints = BREAKPOINTS_SORTED.slice(2)

/**
 * Old theme definition object.
 *
 * Theme keys are based on the System UI spec. Variants are groupings of theme
 * values around specific components or site areas.
 *
 * @see https://system-ui.com/theme
 */
const theme = {
  // System UI keys
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  borderWidth,
  radii,
  space,
  letterSpacings,
  shadows,
  transitions,
  // Variants
  ...variants,
  // Custom
  zIndex,
  bodyFontSize,
  outline,
}

/**
 * These are the current tokens for a light theme, we will be able to remove
 * old tokens when a complete redesign is done
 */
const prism = {
  ...theme,
  colors: {
    ...colors,
    ...light.colors,
    background: {
      ...colors.background,
      ...light.colors.background,
    },
    border: {
      ...colors.border,
      ...light.colors.border,
    },
    brand: {
      beige: {
        50: 'hsl(40, 52%, 25%)',
        100: 'hsl(40, 52%, 75%)',
      },
      green: {
        50: 'hsl(80, 100%, 18%)',
        100: 'hsl(78, 57%, 65%)',
      },
      purple: {
        50: 'hsl(290, 71%, 17%)',
        100: 'hsl(290, 38%, 67%)',
      },
      teal: {
        50: 'hsl(174, 91%, 18%)',
        100: 'hsl(174, 51%, 68%)',
      },
      yellow: {
        50: 'hsl(40, 100%, 24%)',
        100: 'hsl(44, 94%, 69%)',
      },
    },
  },
  fontSizes: prismFontSizes,
  fonts: prismFonts,
  radii: prismRadii,
}

export default prism
